module.exports = __webpack_public_path__ + "img/place-view-tabs01.ac14a096.svg";